import { render } from "./PopupIndex.vue?vue&type=template&id=4618fdfa"
import script from "./PopupIndex.vue?vue&type=script&lang=js"
export * from "./PopupIndex.vue?vue&type=script&lang=js"

import "./PopupIndex.vue?vue&type=style&index=0&id=4618fdfa&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__